"use client";
import localforage from "localforage";
let localForageInstance;
async function fetcherCache() {
  if (!localForageInstance) {
    let localForageInstanceTmp;
    try {
      localForageInstanceTmp = localforage.createInstance({
        name: "CW_fetch_cache",
        storeName: "cache",
        version: 1,
        description: "Persistent cache for native fetch",
        driver: [localforage.INDEXEDDB]
      });
      try {
        await localForageInstanceTmp.ready();
        localForageInstance = localForageInstanceTmp;
      } catch (_) {
        console.error("fetcherCache: localForage not ready");
        localForageInstance = void 0;
      }
    } catch (_) {
      console.error("fetcherCache: cannot create localForage instance");
    }
  }
  return localForageInstance;
}
export {
  fetcherCache
};
